import { render, staticRenderFns } from "./modal-announcement.vue?vue&type=template&id=0d266305&scoped=true&"
import script from "./modal-announcement.vue?vue&type=script&lang=js&"
export * from "./modal-announcement.vue?vue&type=script&lang=js&"
import style0 from "./modal-announcement.vue?vue&type=style&index=0&id=0d266305&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d266305",
  null
  
)

export default component.exports